/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const TENANT_SETTINGS_PERMISSION = {
  CREATE: `TENANT_SETTING_CREATE`,
  DELETE: `TENANT_SETTING_DELETE`,
  READ: `TENANT_SETTING_READ`,
  UPDATE: `TENANT_SETTING_UPDATE`,
};
